'use es6';

import * as CacheKeys from 'reference-resolvers/constants/CacheKeys';
import { getEmailCampaignUrlsById, createGetEmailCampaignUrlsById } from 'reference-resolvers/api/EmailCampaignUrlAPI';
import createBatchedReferenceResolver from 'reference-resolvers/lib/createBatchedReferenceResolver';
export const createEmailCampaignUrlReferenceResolver = options => createBatchedReferenceResolver(Object.assign({
  cacheKey: CacheKeys.EMAILS,
  createFetchSearchPage: createGetEmailCampaignUrlsById,
  fetchSearchPage: getEmailCampaignUrlsById
}, options));
export default createEmailCampaignUrlReferenceResolver();